import React, { useState, useEffect } from "react";
import RequestService from "../services/RequestService";
import { FaCircle } from "react-icons/fa";
import { parseISO, format } from "date-fns";
import DispatchModal from "./modals/DispatchModal";
import RequestDetailsModal from "./modals/RequestDetailsModal";
import { FaLongArrowAltDown } from "react-icons/fa";
import { isSLAPassed, isSLANear, isSLATwoHour } from "../utils/SLACalcs";
import SendToBackOfficeModal from "./modals/SendToBackOfficeModal";
import DepositService from './../services/DepositService';
import { AiFillAlert } from "react-icons/ai";
import { useOutletContext } from 'react-router-dom';

import { IoMdSend } from "react-icons/io";
import { TiArrowBack } from "react-icons/ti";
import { RiTimerLine } from "react-icons/ri";

import StatusRequests from './../enums/StatusRequests';
import SendToManagementModal from './modals/SendToManagementModal';
import { startPolling } from "../utils/polling";




export default function Warehouse() {

  const statusColor = {
    "ATIVO": "#0369a1",
    // "ABERTO": "#fde047",
    "ABERTO": "#60a5fa",
    "EM ANDAMENTO": "#38bdf8",
    "FINALIZADO": "#22c55e",
    "TRIAGEM": "#22c55e",
  }

  const { user } = useOutletContext();

  const [dispatchModal, setDispatchModal] = useState(false);
  const [requestOnDispatchModal, setRequestOnDispatchModal] = useState();
  const [requestNroOnDispatchModal, setRequestNroOnDispatchModal] = useState();
  
  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();

  const [sendToManagementModal, setSendToManagementModal] = useState(false);
  const [requestOnMngtModal, setRequestOnMngtModal] = useState();
  // const [requestNroOnMngtModal, setRequestNroOnMngtModal] = useState();
  
  const [warehouseToHomeModal, setWarehouseToHomeModal] = useState(false);
  const [requestOnWarehouseToHomeModal, setRequestOnWarehouseToHomeModal] = useState();
  const [requestNroOnWarehouseToHomeModal, setRequestNroOnWarehouseToHomeModal] = useState();

  const [depositList, setDepositList] = useState([]);  
  
  //filters
  const [search, setSearch] = useState('');
  const [tempSearch, setTempSearch] = useState(''); // Estado temporário para o input
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchDrsAtender, setSearchDrsAtender] = useState('');
  // const [status, setStatus] = useState('');
    

  const [requestList, setRequestList] = useState({ requests: [], totalPages: 1 });
  const [currentPageRequests, setCurrentPageRequests] = useState(1);

  // ================= USEEFFECT PARA BUSCAR REQUESTS STATUS DEPOSITO =================
  useEffect(()=>{

    // Função para buscar os requests
    const fetchRequests = async () => {
      const status = 'DEPOSITO'
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (status) params.append('status', status);
      if (searchDrsAtender) params.append('drsatender', searchDrsAtender);
    
      const queryString = params.toString();
      const requestsDeposito = await RequestService.getRequest(`?${queryString}`, currentPageRequests);
    
      setRequestList(requestsDeposito);
    };

    fetchRequests()

    return startPolling(fetchRequests);


  }, [currentPageRequests, endDate, search, startDate, warehouseToHomeModal, dispatchModal, searchDrsAtender])

  // ================= USEEFFECT PARA POPULAR DEPOSITOS DA BUSCA =================
  useEffect(() => {
    const fetchData = async () =>{
      const deposits = await DepositService.getDeposits();
      setDepositList(deposits.deposits);
    }
    fetchData();   

  }, []);

  const handlePageChangeRequests = (newPage) => {
    if (newPage >= 1 && newPage <= requestList.totalPages) {
      setCurrentPageRequests(newPage);
    }
  };

  const handleDispatch = async (ticketId, requestNro) => {
    setDispatchModal(true)
    setRequestOnDispatchModal(ticketId)
    setRequestNroOnDispatchModal(requestNro)
  };

  const handleAtendimento = async (ticketId, requestNro) => {
    setWarehouseToHomeModal(true)
    setRequestOnWarehouseToHomeModal(ticketId)
    setRequestNroOnWarehouseToHomeModal(requestNro)
  };

  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };

  

  // ====== FILTER FUNCTIONS ====== 

  const clearFilters = () => {
    setSearch('');
    setTempSearch('');
    setStartDate('');
    setEndDate('');
    setSearchDrsAtender('');
    // setStatus('');
  };

  const handleSearchChange = (e) => {
    // setSearch(e.target.value);
    setTempSearch(e.target.value); // Atualiza o estado temporário
  };

  const handleSearchBlur = () => {
    setSearch(tempSearch); // Atualiza o estado principal quando o input perde o foco
    console.log(tempSearch);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    console.log(e.target.value)
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    console.log(e.target.value)
  };

  // ====== END FILTER FUNCTIONS ====== 

  // const handleStatusChange = (e) => {
  //   setStatus(e.target.value);
  //   console.log(e.target.value)
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Implement your search logic here
    console.log('Search:', search);
    console.log('Start Date:', startDate);
    console.log('End Date:', endDate);
    // console.log('Status:', status);
  };

  const handleGestao = async (ticketId, requestNro) => {
    setSendToManagementModal(true)
    setRequestOnMngtModal(ticketId)
    // setRequestNroOnMngtModal(requestNro)
  };

  const renderFurtoVandalismoFlag = (request) => {
    if (!request?.isFurtoVandalismo) {
      return '-';
    }

    return (
      <div className="flex items-center justify-center gap-1 text-red-600 font-bold whitespace-nowrap">
        <span className="inline-block h-2.5 w-2.5 rounded-full bg-red-500"></span>
      </div>
    );
  };

  
  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">

      <div className="flex flex-col w-full min-h-full rounded-xl py-8 px-6 gap-12 bg-white">

        <div className="flex flex-col gap-2 border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <FaCircle
              color={StatusRequests["DEPOSITO"]?.cor}
              size={15}
            />
            AGUARDANDO SEPARAÇÃO (DEPÓSITO)
          </div>

          <div className="w-full flex flex-col gap-4">

          <div className="flex items-end w-full rounded-md gap-4 mt-2 text-[10px]">
              <div className="flex space-x-4 text-[12px]">
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Pesquisar</label>
                  <input
                    type="text"
                    placeholder="Search"
                    value={tempSearch}  // Vincula o valor ao estado temporário
                    onChange={handleSearchChange}  // Atualiza o estado temporário em tempo real
                    onBlur={handleSearchBlur}  // Atualiza o estado principal ao perder o foco
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Data Início</label>
                  <input
                    type="date"
                    placeholder="Start Date"
                    value={startDate}
                    onChange={handleStartDateChange}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold ms-2">Data Fim</label>
                  <input
                    type="date"
                    placeholder="End Date"
                    value={endDate}
                    onChange={handleEndDateChange}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  />
                </div>
                <div className="flex flex-col w-40">
                  <label className="font-semibold ms-2">DRS Atender</label>
                  <select
                    defaultValue=""
                    value={searchDrsAtender}
                    onChange={(e) => setSearchDrsAtender(e.target.value)}
                    className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                  >
                    <option value="" disabled>Selecione</option>
                    {depositList.map((deposit) => (
                      <option key={deposit._id} value={deposit._id}>
                        {deposit.cidade} - {deposit.sigla}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="flex flex-col">
                  <label className="font-semibold">Status</label>
                  <select
                    value={status}
                    onChange={handleStatusChange}
                    className="border border-gray-300 rounded px-2 py-2"
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div> */}
              </div>

              <div className="flex gap-2">
                {/* <button onClick={handleSubmit} className="bg-zinc-800 hover:bg-zinc-700 text-white h-6 px-4 rounded-2xl w-40">
                  Buscar
                </button> */}
                <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                  Limpar Filtros
                </button>             
              </div>
          </div>

          


            <div className="w-full">
              <div className="overflow-x-auto min-h-48">
                <table className="min-w-full bg-white rounded-lg text-[10px]">
                  <thead className="bg-[#d8b4fe]">
                    <tr>
                      <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                      <th className="py-2 px-4 border-b">ID</th>
                      <th className="py-2 px-4 border-b">Criado em</th>
                      <th className="py-2 px-4 border-b">Cod Sap</th>
                      <th className="py-2 px-4 border-b">Furto/Vand.</th>
                      <th className="py-2 px-4 border-b">Sap Alternativo</th>
                      <th className="py-2 px-4 border-b">DRS Original</th>
                      <th className="py-2 px-4 border-b">DRS a Atender</th>
                      <th className="py-2 px-4 border-b">Qtd a Atender</th>
                      <th className="py-2 px-4 border-b">Atendimento</th>
                      <th className="py-2 px-4 border-b">Técnico</th>
                      <th className="py-2 px-4 border-b">Endereço de Entrega</th>
                      <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                      <th className="py-2 px-4 border-b">Comentário</th>
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requestList.requests?.map((request, index) => (
                      <tr
                        key={`request-${index}`}
                        className={`border-t hover:bg-gray-100 ${isSLAPassed(request.slaDate)
                          ? "bg-red-100"
                          : isSLANear(request.slaDate)
                            ? "bg-yellow-100"
                            : isSLATwoHour(request.slaDate)
                              ? "bg-yellow-200"
                              : ""
                          }`}
                      >
                        <td className="py-1 px-4">
                          <div className="flex justify-center items-center gap-2">
                            <FaCircle
                              color={"#d8b4fe"}
                              size={15}
                            />
                          {request.status}
                          </div>
                        </td>
                        <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={()=>handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                        <td className="py-1 px-4">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</td>
                        <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                        <td className="py-1 px-4 text-center">{renderFurtoVandalismoFlag(request)}</td>
                        <td className="py-1 px-4 whitespace-nowrap">{request.codSapAlternativo}</td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsOriginal.sigla}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsAtender.sigla}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center items-center gap-2">
                            {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                              <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                                {request.tipoAtendimento.toUpperCase()}
                              </span>
                            ) : (
                              request.tipoAtendimento.toUpperCase()
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.tecnico ? request.tecnico : request.user.name}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.cidadeEntrega === 'SÃO PAULO' ? 'SP-' + request.gmo.identificador : request.cidadeEntrega}</div></td>
                        <td
                          className={`py-1 px-4 ${request?.slaDate && isSLAPassed(request.slaDate)
                            ? "text-red-500 font-bold"
                            : request?.slaDate && isSLANear(request.slaDate)
                              ? "text-yellow-600 font-bold"
                              : request?.slaDate && isSLATwoHour(request.slaDate)
                                ? "text-yellow-600 font-bold animate-pulse-fast"
                                : ""
                            }`}
                        >
                          <div className="flex gap-1 items-center font-bold">
                            {request?.slaDate
                              ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                              : "N/A"}
                            {request?.slaDate && isSLATwoHour(request.slaDate) && (
                              <RiTimerLine size={12} />
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4">{request.ultimaObs ? request.ultimaObs : '-'}</td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center gap-2 h-5 text-[11px]">
                            {/* <button 
                              className=" bg-gray-700 rounded-full px-2 py-1 text-white text-sm whitespace-nowrap"
                              onClick={()=>generatePDF(data)}
                            >
                              Nota Embarque
                            </button> */}
                            <button
                              className="flex items-center gap-1 bg-amber-400 rounded-full px-2 text-black"
                              onClick={()=>handleAtendimento(request._id, request.idRequest)}
                            >
                              <TiArrowBack />
                              Backoffice
                            </button>
                            <button
                              className="flex items-center gap-1 bg-sky-700 rounded-full px-2 text-white"
                              onClick={()=>handleDispatch(request._id, request.idRequest)}
                            >
                              Despachar
                              <IoMdSend />
                            </button>
                            {(user.email === 'junior.silva@amerinode.com.br' || user.email === 'guilherme.alberto@amerinode.com.br' ) &&
                              <button
                                className="flex items-center gap-1 bg-rose-800 rounded-full px-2 text-white"
                                onClick={() => handleGestao(request._id, request.idRequest)}
                              >
                                Gestão
                                <AiFillAlert />
                              </button>
                            }
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* Pagination Controls */}
              <div className="flex justify-center items-center mt-4 gap-2 text-xs">
                <button
                  className={`px-2 py-1 rounded-md ${currentPageRequests === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                  onClick={() => handlePageChangeRequests(currentPageRequests - 1)}
                  disabled={currentPageRequests === 1}
                >
                  {'<'}
                </button>
                {[...Array(requestList.totalPages)].map((_, index) => (
                  <button
                    key={index}
                    className={`px-2 py-1 rounded-md ${currentPageRequests === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                    onClick={() => handlePageChangeRequests(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
                <button
                  className={`px-2 py-1 rounded-md ${currentPageRequests === requestList.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                  onClick={() => handlePageChangeRequests(currentPageRequests + 1)}
                  disabled={currentPageRequests === requestList.totalPages}
                >
                  {'>'}
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

      {requestNroOnDispatchModal &&      
      <div className="absolute">
        <DispatchModal
          isModalOpen={dispatchModal}
          setModalOpen={() => {
            setDispatchModal(!dispatchModal);
          }}
          requestId={requestOnDispatchModal}
          requestNro={requestNroOnDispatchModal}
          // setTicketCb={setTicket}
        ></DispatchModal>
      </div>
      }

      

      {requestOnWarehouseToHomeModal && 
      <div className="absolute">
        <SendToBackOfficeModal
          isModalOpen={warehouseToHomeModal}
          setModalOpen={() => {
            setWarehouseToHomeModal(!warehouseToHomeModal);
          }}
          requestId={requestOnWarehouseToHomeModal}
          requestNro={requestNroOnWarehouseToHomeModal}
          // setTicketCb={setTicket}
        ></SendToBackOfficeModal>
      </div>
      }

      {requestOnDetailsModal && 
        <div className="absolute">
          <RequestDetailsModal
            isModalOpen={requestDetailsModal}
            setModalOpen={() => {
              setRequestDetailsModal(!requestDetailsModal);
            }}
            requestId={requestOnDetailsModal}
            // setTicketCb={setTicket}
          ></RequestDetailsModal>
        </div>
      }

      { requestOnMngtModal && 
        <div className="absolute">
          <SendToManagementModal
            isModalOpen={sendToManagementModal}
            setModalOpen={() => {
              setSendToManagementModal(!sendToManagementModal);
            }}
            requestId={requestOnMngtModal}
            // requestNro={requestNroOnMngtModal}
          // setTicketCb={setTicket}
          ></SendToManagementModal>
        </div>
      }


    </div>
  )
}
